/**
 * @holiday-jp/holiday_jp は 1970年〜2050年まで対応。
 * 2051年以降はパッケージのアップデートで追加される。
 *
 * 祝日データの更新:
 * - Dependabot が @holiday-jp/holiday_jp の更新を月次で自動検知し PR を作成する
 *   (.github/dependabot.yml で設定済み)
 * - 臨時祝日（即位の礼等）が制定された場合もパッケージ更新で対応される
 */
import holidayJp from "@holiday-jp/holiday_jp";
/**
 * 指定した日付が日本の祝日かどうかを判定する
 */
export function isJapaneseHoliday(date) {
    return holidayJp.isHoliday(date);
}
/**
 * 指定した日付の祝日名を返す。祝日でなければ undefined
 */
export function getJapaneseHolidayName(date) {
    const holidays = holidayJp.between(date, date);
    if (holidays.length === 0)
        return undefined;
    return holidays[0].name;
}
//# sourceMappingURL=holiday.js.map